<template>
  <div class="result-container">
    <div class="header">
      <van-nav-bar title="答题记录" left-arrow @click-left="goBack" />
    </div>

    <div class="content">
      <div class="records-section">
        <h2>答题记录</h2>
        
        <div class="records-list">
          <div 
            v-for="record in records" 
            :key="record.id"
            class="record-item"
            @click="viewRecordDetail(record)"
          >
            <div class="record-header">
              <div class="category-info">
                <span class="category-name">{{ record.category_name || '未分类' }}</span>
                <span class="separator">→</span>
                <span class="sub-category-name">{{ record.sub_category_name || '未分类' }}</span>
              </div>
              <div class="record-time">{{ formatRecordTime(record.answer_time) }}</div>
            </div>
            <div class="record-body">
              <div class="record-info">
                <span class="label">总用时</span>
                <span class="value">{{ formatTotalTime(record.total_time) }}</span>
              </div>
              <div class="record-info">
                <span class="label">录音数量</span>
                <span class="value">{{ record.question_count || 0 }}题</span>
              </div>
            </div>
            <div class="recording-score">
              <span class="label">录音评分：</span>
              <span class="value" :class="{ 'pending': !record.recording_score }">
                {{ record.recording_score ? record.recording_score + '分' : '老师评分中' }}
              </span>
            </div>
            <div class="recording-comment" v-if="record.recording_comment">
              <span class="label">评语：</span>
              <span class="value">{{ record.recording_comment }}</span>
            </div>
            <div v-if="record.status === 0" class="pending-hint">
              <van-icon name="clock-o" />
              <span>答题进行中...</span>
            </div>
          </div>
          
          <van-empty v-if="records.length === 0" description="暂无答题记录" />
        </div>
      </div>
    </div>

    <div class="footer">
      <van-button type="primary" block round @click="goHome">返回首页</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'Result',
  data() {
    return {
      records: [],
      audioRecords: []
    }
  },
  computed: {
    totalScore() {
      return this.$store.state.user?.total_score || 0
    },
    totalAnswerCount() {
      return this.$store.state.user?.answer_count || 0
    }
  },
  async mounted() {
    await this.loadRecords()
  },
  methods: {
    goBack() {
      const backRoute = this.$store.getters.smartBackRoute
      this.$router.push(backRoute)
    },
    goHome() {
      this.$router.push('/home')
    },
    async loadRecords() {
      try {
        Toast.loading('加载中...')
        console.log('正在获取答题记录...')
        const response = await this.$http.get('/api/answer/my')
        console.log('答题记录响应:', response.data)
        const data = response.data.data || {}
        this.records = (data.records || []).filter(record => record && record.id)
        console.log('答题记录数量:', this.records.length)
        Toast.clear()
      } catch (err) {
        console.error('加载答题记录失败:', err)
        this.records = []
        Toast.clear()
        Toast.fail(err.message || '加载失败')
      }
    },
    viewRecordDetail(record) {
      // 可以在这里跳转到详情页面
      console.log('查看记录详情:', record)
    },
    formatRecordTime(timestamp) {
      if (!timestamp || timestamp === 0 || isNaN(timestamp)) {
        return '未知时间'
      }
      const date = new Date(timestamp * 1000)
      if (isNaN(date.getTime())) {
        return '未知时间'
      }
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
    formatTotalTime(seconds) {
      if (!seconds || seconds === 0 || isNaN(seconds)) {
        return '0秒'
      }
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const secs = seconds % 60
      if (hours > 0) {
        return `${hours}小时${minutes}分${secs}秒`
      } else if (minutes > 0) {
        return `${minutes}分${secs}秒`
      } else {
        return `${secs}秒`
      }
    }
  }
}
</script>

<style scoped>
.result-container {
  min-height: 100vh;
  background: #f8f9ff;
  padding-bottom: 100px;
}

.header {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.content {
  padding: 20px 16px;
}

.score-card {
  background: white;
  border-radius: 20px;
  padding: 36px 28px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
}

.score-icon {
  font-size: 72px;
  margin-bottom: 20px;
}

.score-card h1 {
  font-size: 52px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 10px;
  font-weight: 700;
}

.score-card p {
  font-size: 15px;
  color: #8c8c8c;
  line-height: 1.6;
}

.records-section {
  background: white;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.records-section h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #1a1a2e;
}

.records-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.record-item {
  padding: 20px;
  background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.record-item:active {
  background: #e8f0ff;
  transform: scale(0.98);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.category-info {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #1a1a2e;
}

.category-name {
  font-weight: 600;
  color: #667eea;
}

.separator {
  color: #8c8c8c;
}

.sub-category-name {
  color: #595959;
  font-weight: 500;
}

.record-time {
  font-size: 12px;
  color: #8c8c8c;
}

.record-body {
  display: flex;
  justify-content: space-between;
  padding-top: 14px;
  border-top: 1px solid #f0f0f0;
}

.record-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}

.record-info .label {
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 500;
}

.record-info .value {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
}

.record-info .value.pending {
  color: #fa8c16;
}

.pending-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 14px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%);
  border-radius: 10px;
  font-size: 13px;
  color: #fa8c16;
  font-weight: 500;
}

.recording-score {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 14px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);
  border-radius: 10px;
  font-size: 13px;
}

.recording-score .label {
  color: #595959;
  font-weight: 500;
}

.recording-score .value {
  font-weight: 700;
  color: #1890ff;
}

.recording-score .value.pending {
  color: #fa8c16;
}

.recording-comment {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 14px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%);
  border-radius: 10px;
  font-size: 13px;
}

.recording-comment .label {
  color: #595959;
  font-weight: 500;
  flex-shrink: 0;
}

.recording-comment .value {
  font-weight: 500;
  color: #52c41a;
  line-height: 1.5;
}

.footer {
  font-size: 14px;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 20px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  background: white;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
}

.footer .van-button {
  height: 52px;
  font-size: 17px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}
</style>